import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9.5 3q2.725 0 4.612 1.888T16 9.5a6.1 6.1 0 0 1-1.3 3.8l6.3 6.3-1.4 1.4-6.3-6.3q-.75.6-1.725.95T9.5 16q-2.725 0-4.612-1.888T3 9.5t1.888-4.612Q6.775 3 9.5 3m0 2Q7.625 5 6.313 6.313 5 7.625 5 9.5t1.313 3.188T9.5 14t3.188-1.312T14 9.5t-1.312-3.187T9.5 5" })
});
export default SvgSearch;
